export class EnsureSchoolCoordinatorsLoaded {
  static readonly type =
    "[School Coordinators] Ensure School Coordinators Loaded";
}

export class ReloadSchoolCoordinators {
  static readonly type = "[School Coordinators] Reload School Coordinators";
}
